<template>
<v-app>
  <prb-toolbar v-bind:disable="!terms"></prb-toolbar>
  <prb-terms v-bind:termsDialog="!terms"></prb-terms>
  <main>
    <v-container fluid>
      <v-layout class="download__layout">
        <v-flex xs12>
          <div class="download__layout-card">
            <v-card>
              <v-card-title class="pa-0">
                <div class="top__layout-title">Download</div>
              </v-card-title>
              <v-card-text class="blue-grey lighten-5 mb-2">
                <p> - All the data calculated from the medicinal chemistry data available in canSAR (Tym et al., 2016; <a :href="apiUrl" target="_blank">{{apiUrl}}</a>) can be downloaded from the link below, including a list of all 355,305 human active compounds against all their human targets and their individual as well as global scores.</p>
                <div class="text-sm-center">
                  <a href="probeminer_datadump.zip" target="_blank" class="link-download" download>
                    <v-btn class="blue-grey white--text">DOWNLOAD .TSV FILE</v-btn>
                  </a>
                </div>
                <div class="text-sm-center">
                  <a rel="license" href="http://creativecommons.org/licenses/by/4.0/"><img alt="Creative Commons License" style="border-width:0" src="https://i.creativecommons.org/l/by/4.0/88x31.png" /></a><br />This work is licensed under a <a rel="license" href="http://creativecommons.org/licenses/by/4.0/">Creative Commons Attribution 4.0 International License</a>
                </div>
              </v-card-text>
              <v-card-text class="blue-grey lighten-5">
                <p> - The Pipeline Pilot 9.5 protocol created by Gary Nugent to calculate the level 1 scaffolds (Langdon et al., 2011)</p>
                <div class="text-sm-center">
                  <a href="Generate_level1_Scaffolds_from_smiles.xml.zip" target="_blank" class="link-download" download>
                    <v-btn class="blue-grey white--text">DOWNLOAD PIPELINE PILOT PROTOCOL</v-btn>
                  </a>
                </div>
                <div class="text-sm-center">
                  <a rel="license" href="http://creativecommons.org/licenses/by/4.0/"><img alt="Creative Commons License" style="border-width:0" src="https://i.creativecommons.org/l/by/4.0/88x31.png" /></a><br />This work is licensed under a <a rel="license" href="http://creativecommons.org/licenses/by/4.0/">Creative Commons Attribution 4.0 International License</a>
                </div>
              </v-card-text>
            </v-card>
          </div>
        </v-flex>
      </v-layout>
    </v-container>
  </main>
  <prb-footer></prb-footer>
</v-app>
</template>

<script>
import {
  mapGetters
} from 'vuex'

import PrbToolbar from './prb-toolbar/PrbToolbar';
import PrbTerms from './prb-terms/PrbTerms';
import PrbFooter from './prb-footer/PrbFooter';

export default {
  components: {
    PrbToolbar,
    PrbTerms,
    PrbFooter
  },
  computed: mapGetters([
    'termsVerified'
  ]),
  metaInfo: {
    title: 'Probe Miner',
    titleTemplate: '%s | Download'
  },
  name: 'prbdownload',
  computed: {
    terms: {
      get() {
        return this.$store.state.termsVerified
      }
    }
  },
  data() {
    return {
      apiUrl: process.env.API_URL,
      termsDialog: true,
      search: null,
      e1: 1
    }
  }
}
</script>

<style scoped>
.download__layout {
  height: 100%;
  background: url(../img/layer6.png) no-repeat center center fixed;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
}

.download__layout-card {
  padding: 5% 5% 0 5%;
}

.top__layout-title {
  width: 100%;
  font-size: 30px;
  padding: 10px;
  font-weight: 300;
  background-color: #455A64;
  color: white;
  margin: 0 0 5px 0;
}

.link-download {
  text-decoration:none;
}

@media screen and (max-width: 1600px) {
  .download__layout-card {
    padding: 2% 2% 0 2%;
  }
}

@media screen and (max-width: 800px) {
  .download__layout-card {
    padding: 2% 0 0 0;
  }
}
</style>



// WEBPACK FOOTER //
// PrbDownload.vue?5f5eab56